export const INSURANCE_CHART_COLORS = [
  "#1E61DC",
  "#60A5FA",
  "#93C5FD",
  "#BFDBFE",
  "#3B82F6",
  "#2563EB",
  "#1D4ED8",
];

export const formatInsuranceMoney = (
  amount,
  currency = "NGN",
  locale = "en-US",
) => {
  let formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0);

  if (currency === "NGN") {
    formatted = formatted.replace(/^NGN/, "₦");
  } else if (currency === "USD") {
    formatted = formatted.replace(/^USD/, "$");
  }

  return formatted;
};

export const formatInsurancePercentage = (value) => {
  const numericValue = Number(value) || 0;

  return `${numericValue.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })}%`;
};

export const getInsuranceSummaryCards = (summaryMetrics) =>
  Object.values(summaryMetrics || {});

export const getInsuranceTrendData = (trendPayload) => {
  const labels = trendPayload?.labels || [];
  const datasets = trendPayload?.datasets || [];

  const revenueDataset = datasets.find((item) =>
    item?.label?.toLowerCase().includes("revenue"),
  );
  const policiesDataset = datasets.find((item) =>
    item?.label?.toLowerCase().includes("polic"),
  );

  return labels.map((label, index) => ({
    month: label,
    revenue: revenueDataset?.data?.[index] || 0,
    policies: policiesDataset?.data?.[index] || 0,
  }));
};

export const getInsurancePolicyTypeBreakdown = (breakdownsData) =>
  breakdownsData?.data?.policyTypeBreakdown?.map((item) => ({
    ...item,
    name: item.policyType || item.label || item.category || "Unknown policy",
    value: item.revenue || item.amount || 0,
    sharePercentage: item.sharePercentage || 0,
  })) || [];

export const getInsuranceUserTypeBreakdown = (breakdownsData) =>
  breakdownsData?.data?.revenueByUserType?.map((item) => ({
    ...item,
    name: item.userType,
    value: item.revenue,
  })) || [];
